import { createContext, useContext, useEffect, useState } from "react";
import axios from "axios";
import * as DEFAULTS from "@/site";

const ContentContext = createContext(DEFAULTS);

export const ContentProvider = ({ children }) => {
  const [content, setContent] = useState(DEFAULTS);

  useEffect(() => {
    axios
      .get(`${process.env.REACT_APP_BACKEND_URL}/api/content`)
      .then(({ data }) => {
        if (data && typeof data === "object" && Object.keys(data).length) setContent({ ...DEFAULTS, ...data });
      })
      .catch(() => {});
  }, []);

  return <ContentContext.Provider value={content}>{children}</ContentContext.Provider>;
};

export const useContent = () => useContext(ContentContext);
